import React, { useState } from 'react'
import '../styles/SelectCity.css'

const SelectCity = (props) => {
    const { areaSelect, getAreaSelected, DropdownDefault, isDropdownOpen, handleDropdown } = props;
    const cityList = ['경기도', '경상남도', '부산광역시', '인천광역시', '전라북도', '전라남도', '충청남도', '울산광역시', '강원도', '경상북도', '제주특별자치도'];
    const [SelectCityList,] = useState([...cityList])
    const [SelectCountyList, setSelectCountyList] = useState([])

    // console.log(areaSelect, 'areaSelect')

    const handleCityChange = (city) => {
        const selectedCityCounty = areaSelect.filter((item) => item.SD === city)
        const filteredCounty = selectedCityCounty.filter((item1, index1) => {
            return selectedCityCounty.findIndex((item2, index2) => {
                return item1.SG === item2.SG;
            }) === index1;
        });
        const sortedCounty = filteredCounty.sort((a, b) => {
            return a.SG < b.SG ? -1 : a.SG > b.SG ? 1 : 0;
        })
        setSelectCountyList([...sortedCounty]);
    }

    const renderCityOptions = SelectCityList.map((item, index) => {
        return (
                <div key={index} onClick={() => handleCityChange(item)} >{item}</div>

        )
    })

    const renderCountyOptions = SelectCountyList.map((item, index) => {
        const value = `${item.coordinates},${item.SG},${item.SD}`;
        return (
            <>
                {DropdownDefault.SG === item.SG ?
                    <div key={index} value={value} onClick={() => getAreaSelected(value)} style={{ backgroundColor: "#DFF3F6", color: "#00B9E1" }}>{item.SG}</div>
                    :
                    <div key={index} value={value} onClick={() => getAreaSelected(value)}>{item.SG}</div>
                }
            </>
        )
    })

    return (
        <>
            <div className="dropdown">
                <button className="dropbtn" onClick={handleDropdown}>
                    {/* 지역선택 */}
                    {DropdownDefault.SG ?
                        <span className="dropbtn-selected">{DropdownDefault.SG}</span> :
                        <div>지역선택</div>
                    }
                    <img src="./images/dropdownIcon.svg" alt="v"></img>
                </button>

                <div className="dropdown-content"
                    style={{ display: isDropdownOpen ? 'grid' : 'none' }}>
                    <div className="dropdown-selectInfo" onClick={handleDropdown}>
                        <div>지역선택</div>
                        <img src="./images/dropdownIcon.svg" alt="^" style={{
                            transform: `rotate(${180}deg)`
                        }}></img>
                    </div>
                    <div
                        className="dropdown-korea"
                        onClick={() => getAreaSelected('대한민국')}>대한민국</div>
                    <div className="dropdown-city">
                        {renderCityOptions}
                    </div>

                    {SelectCountyList[0] &&
                        <div className="dropdown-county">
                            {renderCountyOptions}
                        </div>
                    }
                </div>
            </div>
        </>
    )
}

export default SelectCity
